import { Check, Moon, Smartphone, Sun } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useTheme, type ThemeMode } from '../../context/ThemeContext';

const OPTIONS: { value: ThemeMode; tone: 'light' | 'system' | 'dark'; labelKey: string; descKey: string }[] = [
  { value: 'light', tone: 'light', labelKey: 'settings.themeLight', descKey: 'settings.themeLightDesc' },
  { value: 'dark', tone: 'dark', labelKey: 'settings.themeDark', descKey: 'settings.themeDarkDesc' },
];

function ThemeIcon({ tone }: { tone: (typeof OPTIONS)[number]['tone'] }) {
  if (tone === 'light') return <Sun size={22} strokeWidth={1.9} />;
  if (tone === 'dark') return <Moon size={22} strokeWidth={1.9} />;
  return <Smartphone size={22} strokeWidth={1.9} />;
}

export function OnboardingThemePicker() {
  const { t } = useTranslation();
  const { mode, setMode } = useTheme();

  return (
    <div className="cs-onboarding-theme" role="radiogroup" aria-label={t('settings.appearance')}>
      {OPTIONS.map((opt) => {
        const active = mode === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={active}
            className={`cs-onboarding-theme__card cs-onboarding-theme__card--${opt.tone}${
              active ? ' cs-onboarding-theme__card--active' : ''
            }`}
            onClick={() => setMode(opt.value)}
          >
            <span className="cs-onboarding-theme__check" aria-hidden>
              {active ? <Check size={12} strokeWidth={3} /> : null}
            </span>
            <span className="cs-onboarding-theme__preview" aria-hidden>
              <span className="cs-onboarding-theme__preview-bar" />
              <span className="cs-onboarding-theme__preview-block" />
              <span className="cs-onboarding-theme__preview-block cs-onboarding-theme__preview-block--short" />
            </span>
            <span className="cs-onboarding-theme__icon" aria-hidden>
              <ThemeIcon tone={opt.tone} />
            </span>
            <strong>{t(opt.labelKey)}</strong>
            <span>{t(opt.descKey)}</span>
          </button>
        );
      })}
    </div>
  );
}
